<template>
  <div>
    <ClosedTemplate>
      <template v-slot:title>
        <span v-html="$t('closed.before.title')"></span>
      </template>
      <template v-slot:donate-info>
        <span v-html="$t('closed.before.donate-info')"></span>
      </template>
    </ClosedTemplate>
  </div>
</template>
<script>
import ClosedTemplate from '@/components/widgets/ClosedTemplate.vue'

export default {
  name: 'ClosedBefore',
  components: {
    ClosedTemplate
  }
}
</script>
